"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulletListType = void 0;
/**
 *  Enum used to control the different types of bullet list
 */
var BulletListType;
(function (BulletListType) {
    /**
     * Minimum value of the enum
     */
    BulletListType[BulletListType["Min"] = 1] = "Min";
    /**
     * Bullet triggered by *
     */
    BulletListType[BulletListType["Disc"] = 1] = "Disc";
    /**
     * Bullet triggered by -
     */
    BulletListType[BulletListType["Dash"] = 2] = "Dash";
    /**
     * Bullet triggered by --
     */
    BulletListType[BulletListType["Square"] = 3] = "Square";
    /**
     * Bullet triggered by >
     */
    BulletListType[BulletListType["ShortArrow"] = 4] = "ShortArrow";
    /**
     * Bullet triggered by -> or -->
     */
    BulletListType[BulletListType["LongArrow"] = 5] = "LongArrow";
    /**
     * Bullet triggered by =>
     */
    BulletListType[BulletListType["UnfilledArrow"] = 6] = "UnfilledArrow";
    /**
     * Bullet triggered by —
     */
    BulletListType[BulletListType["Hyphen"] = 7] = "Hyphen";
    /**
     * Maximum value of the enum
     */
    BulletListType[BulletListType["Max"] = 7] = "Max";
})(BulletListType = exports.BulletListType || (exports.BulletListType = {}));
//# sourceMappingURL=BulletListType.js.map